module.exports = __webpack_public_path__ + "img/bot.23fa67e4.png";